import Vue from 'vue'

const getDefaultState = () => {
  return {
    alarmHistory: [],
    status: 'empty'
  }
}

function sortByAlarmAt (a, b) {
  if (a.lastAlarmAt && b.lastAlarmAt) return new Date(b.lastAlarmAt) - new Date(a.lastAlarmAt)
  return new Date(b.alarmAt) - new Date(a.alarmAt)
}

// initial state
const state = getDefaultState()

// getters
const getters = {
  all: state => state.alarmHistory
}

// actions
const actions = {
  async fetchAlarmHistory ({ commit, dispatch }, alarmId) {
    const res = await Vue.axios.get(`/api/alarms/${alarmId}/history`)
    if (res.status === 200) commit('setAlarms', res.data.alarms)
  },

  resetAlarmHistory ({ state, commit }) {
    commit('resetState')
  }
}

// mutations
const mutations = {
  setAlarms (state, alarms) {
    state.alarmHistory = alarms.sort(sortByAlarmAt)
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alarmHistory.js